const upcomingFeatures = [
  {
    icon: 'ri-syringe-line',
    title: 'Vaccine Schedule',
    description: 'Auto-generated vaccine timeline based on your baby\'s birth date'
  },
  {
    icon: 'ri-notification-3-line',
    title: 'Smart Reminders',
    description: 'Timely alerts for vaccines and checkups&nbsp; never miss a due date'
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Growth Tracking',
    description: 'Monitor weight, height, and developmental milestones month by month'
  },
  {
    icon: 'ri-parent-line',
    title: 'Personalized Alerts',
    description: 'Custom notifications for your baby\'s age and health milestones'
  }
];

export default function PostCare() {
  return (
    <section id="baby-care" className="py-20 sm:py-28 bg-gradient-to-br from-rose-50 via-pink-50 to-rose-50 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-rose-100/50 rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-60 h-60 bg-pink-100/50 rounded-full -translate-x-1/3 translate-y-1/3 blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-rose-100 border border-rose-200 rounded-full">
                <i className="ri-rocket-line text-rose-600"></i>
                <span className="text-sm font-bold text-rose-700">Launching Soon</span>
              </div>
              <span className="text-xs font-semibold text-rose-500 bg-rose-100 px-3 py-1 rounded-full border border-rose-200 animate-pulse">New Feature</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-5 leading-tight">
              Coming Soon:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-pink-500">
                Baby Care (0–5 Years)
              </span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Your journey doesn't end at delivery. We're building a complete baby care module to help you track vaccines, growth milestones, and developmental checkups from birth to 5 years.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {upcomingFeatures.map((feat, index) => (
                <div key={index} className="bg-white rounded-xl p-4 border border-rose-100 flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-rose-50 rounded-xl shrink-0">
                    <i className={`${feat.icon} text-xl text-rose-500`}></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm mb-0.5">{feat.title}</div>
                    <div className="text-gray-500 text-xs leading-relaxed">{feat.description}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-7 py-3.5 bg-gradient-to-r from-rose-500 to-pink-500 text-white rounded-xl font-bold text-sm hover:from-rose-600 hover:to-pink-600 transition-all hover:-translate-y-1 inline-flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-bell-line"></i>
                Get Notified at Launch
              </button>
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <i className="ri-time-line text-rose-400"></i>
                <span>Expected Launch: 2026</span>
              </div>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden h-80 sm:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/ac9b9b3b0a26dfcfb283047d8b6d8f09.jpg"
                alt="Mother and baby"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-rose-900/20 to-transparent"></div>
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-4 -left-4 sm:-left-8 bg-white rounded-2xl p-4 border border-rose-100 max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 flex items-center justify-center bg-rose-50 rounded-lg">
                  <i className="ri-syringe-line text-rose-500 text-lg"></i>
                </div>
                <span className="font-bold text-gray-900 text-sm">Next Vaccine</span>
              </div>
              <div className="text-gray-600 text-xs">
                <strong className="text-gray-900">DPT (1st dose)</strong> Due at 6 weeks
              </div>
              <div className="mt-2 flex items-center gap-1.5">
                <span className="w-2 h-2 bg-rose-400 rounded-full animate-pulse inline-block"></span>
                <span className="text-xs text-rose-500 font-medium">Reminder set for 7 days before</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
